// extracted by mini-css-extract-plugin
export default {"fieldset":"FormGroup_fieldset__0Zlh0","legend":"FormGroup_legend__BVuGw"};